import SelectRegion from './SelectRegion';
export default SelectRegion;



// WEBPACK FOOTER //
// ./src/pages/SubmissionCrmErrorsPage/components/SelectRegion/index.ts